import { render } from "./CsvPreview.vue?vue&type=template&id=2612dc48&scoped=true"
import script from "./CsvPreview.vue?vue&type=script&lang=js"
export * from "./CsvPreview.vue?vue&type=script&lang=js"

import "./CsvPreview.vue?vue&type=style&index=0&id=2612dc48&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2612dc48"]])

export default __exports__